// https://www.youtube.com/watch?v=GuHN_ZqHExs
import { GoogleLogin,googleLogout } from "@react-oauth/google"
import { jwtDecode } from "jwt-decode"
import {useNavigate } from 'react-router-dom';

export default function Login(){
    const navigate = useNavigate()

    function handleLogout(){
        googleLogout()
    }
    return(
        <>
        <div   style={{marginBottom:30, justifyItems:"right",marginTop:-30}}>
        <GoogleLogin
     
        onSuccess={(credentialResponse)=>{
            console.log(credentialResponse)
            console.log("info: ",jwtDecode(credentialResponse.credential))
            navigate('/about-us')
        }}
        onError={()=>alert("Login failed!")}
        auto_select={true}
        size="small"
        shape="pill"
        width={100}
        height={50}
        theme="outline"
        logo_alignment="center"
        text="hi"
        />
        </div>
        </>
    )
}